<template>
	<div>
		<div class="modal fade" id="excelModal" data-backdrop="static">
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<button
							type="button"
							class="close"
							data-dismiss="modal"
							aria-label="Close"
						>
							<span aria-hidden="true">&times;</span>
						</button>
						<h4 class="modal-title" id="myModalLabel">
							Importar Exame
						</h4>
					</div>
					<div class="modal-body">
						<div class="col-sm-12">
							<div v-if="!loading">
								<span>Arquivo Excel</span>

								<input
									type="file"
									id="fileUpload"
									v-on:change="handleTest($event)"
									accept=".xls,.xlsx,.ods,.csv"
								/>

								<p>.xls,.xlsx,.ods,.csv</p>
							</div>
						</div>
						<div v-if="loading">
							<i
								data-v-4481e0c6=""
								class="fa fa-spin fa-spinner"
							></i>
							Carregando...
						</div>

						<br />

						<button
							type="button"
							class="btn btn-default"
							data-dismiss="modal"
						>
							<i class="fa fa-close"></i> Cancelar
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	/*

	id precisa existir para poder ocorrer a criação

	*/
	import clone from 'js/clone';
	import aBox from 'box';
	import aBtn from 'btn';
	import WBS from 'js/http';
	import toastr from 'toastr';
	import axios from 'axios';
	import moment from 'moment';
	// import "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.5/jszip.js";
	// import "https://cdnjs.cloudflare.com/ajax/libs/xlsx/0.13.5/xlsx.full.min.js";

	var XLSX = require('xlsx');

	let reset = {
		empresa: '',
		nome: '',
		colaborador: '',
		cargo: '',
		navio: '',
		frota: '',
		idade: 0,
		tipoDoTeste: '',
		localTeste: '',
		dataTeste: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		laboratorio: '',
		parceiro: '',
		dataResultado: `${new Date().getFullYear()}-${
			new Date().getMonth() + 1 < 10 && 0
		}${new Date().getMonth() + 1}-${new Date().getDate()}T${
			new Date().getHours() < 10 ? 0 : ''
		}${new Date().getHours()}:${
			new Date().getMinutes() <= 10 ? 0 : ''
		}${new Date().getMinutes()}`,
		tempoResultado: 0,
		tempoResultadoFormatado: 'dias: 0, horas: 0, minutos: 0',
		resultado: false,
		municipio: '',
		estado: '',
		RG: '',
		CPF: '',
	};

	// console.log("reset.dataTeste")
	// console.log(reset.dataTeste)
	// console.log("2022-04-26T05:20")

	export default {
		name: 'ChModalExames',
		components: { aBox, aBtn },
		data() {
			return {
				data: clone(reset),
				loading: false,
			};
		},
		methods: {
			async handleTest(e) {
				let x = this.checkfile(e.target);
				console.log('x', x);
			},

			checkfile(sender) {
				var validExts = new Array('.xlsx');
				var fileExt = sender.value;
				fileExt = fileExt.substring(fileExt.lastIndexOf('.'));
				if (validExts.indexOf(fileExt) < 0) {
					alert(
						'Invalid file selected, valid files are of ' +
							validExts.toString() +
							' types.'
					);
					return false;
				} else return this.processExcel();
			},

			processExcel() {
				var fileUpload = document.getElementById('fileUpload');
				if (typeof FileReader != 'undefined') {
					var reader = new FileReader();
					//For Browsers other than IE.

					if (reader.readAsBinaryString) {
						// console.log(this)
						const readExcel = (e) => this.readExcel(e);

						reader.onload = function (e) {
							return readExcel(e.target.result);
						};

						reader.readAsBinaryString(fileUpload.files[0]);
					} else {
						//For IE Browser.
						reader.onload = function (e) {
							var data = '';
							var bytes = new Uint8Array(e.target.result);

							for (var i = 0; i < bytes.byteLength; i++) {
								data += String.fromCharCode(bytes[i]);
							}

							return this.readExcel(data);
						};
						reader.readAsArrayBuffer(fileUpload.files[0]);
					}
				} else {
					alert('This browser does not support HTML5.');
				}
			},

			readExcel(data) {
				let excelRows;
				var workbook = XLSX.read(data, {
					type: 'binary',
				});
				var firstSheet = workbook.SheetNames[0];
				excelRows = XLSX.utils.sheet_to_row_object_array(
					workbook.Sheets[firstSheet],
					{
						raw: false,
					}
				);

				const formatedRows = this.handleNormalizeData(excelRows);

				console.log(formatedRows);

				this.sendRequisitions(formatedRows);
			},

			handleNormalizeData(excelRows) {
				const normalizeBrazilianDateString = (e) =>
					this.normalizeBrazilianDateString(e);
				const handleChangeKey = (e) => this.handleChangeKey(e);
				let formatedExcelRows = [];

				excelRows.map((row) => {
					let newRow = {};

					Object.keys(row).map(function (value, label) {
						const newRowKey = handleChangeKey(value);

						let newRowValue = row[value];

						if (
							value == 'data do teste' ||
							value == 'data do resultado'
						) {
							newRowValue = normalizeBrazilianDateString(
								row[value]
							);
						}

						if (
							value == 'rg/pass' ||
							value == 'cpf' ||
							value == 'idade' ||
							value == 'tempo de análise'
						) {
							newRowValue = parseInt(row[value]);
						}

						newRow[newRowKey] = newRowValue;
					});

					formatedExcelRows.push(newRow);
				});

				return formatedExcelRows;
			},

			// converts the keys from a the converted XLSX to JSON to php array data
			handleChangeKey(key) {
				/*
				convert this:
					"laboratório": "CTESTE"
				to this:
					data[laboratorio]: "CTESTE"
				*/

				switch (key) {
					// value
					case 'cargo':
						return 'cargo';
						break;

					case 'cpf':
						return 'CPF';
						break;

					case 'resultado':
						return 'resultado';
						break;

					case 'empresa':
						return 'empresa';
						break;

					case 'estado':
						return 'estado';
						break;

					case 'frota':
						return 'frota';
						break;

					case 'idade':
						return 'idade';
						break;

					case 'nome':
						return 'colaborador';
						break;

					case 'parceiro':
						return 'parceiro';
						break;

					case 'exame': //NÃO EXISTE NO ARQUIVO ENVIADO
						return 'nome';
						break;

					case 'navio': //NÃO EXISTE NO ARQUIVO ENVIADO
						return 'navio';
						break;

					case 'laboratório':
						return 'laboratorio';
						break;

					case 'seção':
						return 'secao';
						break;

					case 'município':
						return 'municipio';
						break;

					case 'rg/pass':
						return 'RG';
						break;

					// "Value of something"

					case 'data do resultado':
						return 'dataResultado';
						break;

					case 'local do teste':
						return 'localTeste';
						break;

					case 'data do teste':
						return 'dataTeste';
						break;

					case 'tempo de análise':
						return 'tempoResultado';
						break;

					case 'tipo de teste':
						return 'tipoDoTeste';
						break;

					// default:
					// 	break;
				}
			},

			normalizeBrazilianDateString(date) {
				// "05/07/2022"

				const day = date.split('/')[0];
				const month = date.split('/')[1];
				const year = date.split('/')[2];

				const normalizedDate =
					year +
					'-' +
					('0' + month).slice(-2) +
					'-' +
					('0' + day).slice(-2);
				// "2022-07-05"
				return normalizedDate;
				// slice is used to guarantee the 2 digits format
			},

			sendRequisitions(formatedRows) {
				this.loading = true;

				WBS.send('private-custom-exams', formatedRows, (resp) => {
					this.loading = false;

					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#excelModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});
			},

			open(data = null) {
				if (data != null) this.data = clone(data);
				else this.data = clone(reset);
				$('#excelModal').modal('show');
			},

			save() {
				WBS.send('private-save-exams', this.data, (resp) => {
					if (resp.status == 'success') {
						toastr.success('Registro alterado com sucesso!');
						this.$emit('update');
						$('#excelModal').modal('hide');
					} else {
						toastr.error(resp.msgs[0]);
						console.log(resp);
						console.log(this.data);
					}
				});
			},

			onSelectState() {
				console.log(this.data.estado);
				axios
					.get(
						`https://servicodados.ibge.gov.br/api/v1/localidades/estados/${this.data.estado}/municipios?orderBy=nome`
					)
					.then((response) => (this.municipios = response.data));
			},
		},

		mounted() {
			axios
				.get(
					'https://servicodados.ibge.gov.br/api/v1/localidades/estados?orderBy=nome'
				)
				.then((response) => (this.estados = response.data));
		},
	};
</script>



// WEBPACK FOOTER //
// src/components/cadastros/navio/modal2.vue